(function () {

    angular
        .module('smartertoolsApp')
        .directive('multiEmailValidator', multiEmailValidator);

    function multiEmailValidator() {
        const emailRegexp =
            /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {
                if (ctrl && ctrl.$validators.email) {
                    ctrl.$validators.email = function (modelValue) {

                        let isValidEmails;
                        if (angular.isDefined(modelValue)) {
                            isValidEmails = ctrl.$isEmpty(modelValue) ||
                                modelValue.split(',').every((email) => emailRegexp.test(email.trim())) ||
                                modelValue.split(';').every((email) => emailRegexp.test(email.trim()));
                        }

                        ctrl.$setValidity('multi-email', isValidEmails);

                        return isValidEmails;
                    };
                }
            }
        };
    }

})();